import Vue from "vue";
class TransferService {

  Gaau(model) {
    return Vue.prototype.$http({
      url: "/transfer/gaau",
      data: model,
      method: "POST"
    });
  }

  Inventory(model) {
    return Vue.prototype.$http({
      url: "/transfer/inventory",
      data: model,
      method: "POST"
    });
  }

  
}

export default new TransferService();
